import React from 'react'
import Typography from "@material-ui/core/Typography";
import Typical from "react-typical";
import {AwesomeButton} from "react-awesome-button";
import {Parallax, ParallaxLayer} from "react-spring/renderprops-addons";
import me from "../Img/Me.jpeg";
import logo from "../Img/logo.svg";
import javaScriptIcon from "../Img/javaScriptLogo.png";
import html from "../Img/html.png";
import css from "../Img/cssLogo.png";
import {isMobile, withOrientationChange} from "react-device-detect";
import App from "../App";


const statePortrait = {
    typicalMessage: [750, 'Welcome', 1500, '', 750, 'ようこそ', 1500, '', 750, '어서 오십시오', 1500, '',],

    typicalTextWidth: '13vw',

    awesomeButtonStyle: {
        position: 'absolute',
        left: 0,
        right: 0,
        margin: 'auto',
        bottom: '80vh',
        top: '35vh',
        height: '4.5vh'
    },

    logo1Position: 1.14,
    logo1Style: {display: 'block', marginLeft: '10%', width: '20%'},

    logo2Position: 1.15,
    logo2Style: {display: 'block', marginLeft: '35%', width: '10%'},

    logo3Position: 1.15,
    logo3Style: {display: 'block', marginLeft: '55%', width: '10%'},

    logo4Position: 1.15,
    logo4Style: {display: 'block', marginLeft: '75%', width: '10%'},

    myPictureStyle: {display: 'block', margin: 'auto', width: '25vh'},
    myPicturePosition: 1.3,

    aboutMeTitlePosition: 1.23,
    aboutMeTitleStyle: {color: 'white', display: 'block', align: 'center', top: '25%', fontSize: '3vh'},
    aboutMeTitleAlign: 'center',

    aboutMeBodyPosition: 1.7,
    aboutMeBodyStyle: {
        color: 'white',
        marginLeft: '10%',
        top: '30%',
        marginRight: '10%',
        fontSize: '1.7vh'
    },
    aboutMeBodyAlign: 'center',

}

const stateLandscape ={
    widthDetected: false,
    typicalTextWidth: '10vw',
    typicalMessage: [750, 'Welcome', 1500, '', 750, 'ようこそ', 1500, '', 750, '어서 오십시오', 1500, '',],

    awesomeButtonStyle: {position: 'absolute', left: 0, right: 0, margin: 'auto', bottom: '80vh', top: '35vh', height: '4.5vh'},

    myPictureStyle: {display: 'block',marginLeft: '20%', width: '25vw'},
    myPicturePosition: 1.25,


    logo1Position: 1.2,
    logo1Style: {display: 'block',marginLeft: '5%', width: '10%'},

    logo2Position: 1.4,
    logo2Style: {display: 'block',marginLeft: '7.5%', width: '5%'},

    logo3Position: 1.6,
    logo3Style: {display: 'block',marginLeft: '7.5%', width: '5%'},

    logo4Position: 1.8,
    logo4Style: {display: 'block',marginLeft: '7.5%', width: '5%'},

    aboutMeTitlePosition: 1.23,
    aboutMeTitleStyle: {color: 'white', marginLeft: '50%', top: '25%', fontSize: '3vw'},
    aboutMeTitleAlign: 'left',

    aboutMeBodyPosition: 1.33,
    aboutMeBodyStyle: {height: '200px',
        width: '300em', color: 'white', marginLeft: '50%', top: '30%',marginRight: '10%', fontSize: '1.5vw'},

    aboutMeBodyAlign: 'left,'
}


const stateDesktop = {
    widthDetected: false,
    typicalTextWidth: '7vw',
    typicalMessage: [750, 'Welcome', 1500, '', 750, 'ようこそ', 1500, '', 750, '어서 오십시오', 1500, '',],

    awesomeButtonStyle: {position: 'absolute', left: 0, right: 0, margin: 'auto', bottom: '80vh', top: '35vh', height: '4.5vh'},

    myPictureStyle: {display: 'block',marginLeft: '20%', width: '25%'},
    myPicturePosition: 1.25,


    logo1Position: 1.2,
    logo1Style: {display: 'block',marginLeft: '5%', width: '10%'},

    logo2Position: 1.4,
    logo2Style: {display: 'block',marginLeft: '7.5%', width: '5%'},

    logo3Position: 1.6,
    logo3Style: {display: 'block',marginLeft: '7.5%', width: '5%'},

    logo4Position: 1.8,
    logo4Style: {display: 'block',marginLeft: '7.5%', width: '5%'},

    aboutMeTitlePosition: 1.2,
    aboutMeTitleStyle: {color: 'white', marginLeft: '50%', top: '25%', fontSize: '3vw'},
    aboutMeTitleAlign: 'left',

    aboutMeBodyPosition: 1.3,
    aboutMeBodyStyle: {height: '200px',
        width: '300px',color: 'white', marginLeft: '50%', top: '30%',marginRight: '10%', fontSize: '1.5vw'},

    aboutMeBodyAlign: 'left'
}


class IntroPage extends React.Component{

    constructor(props) {

        super(props);

        if(isMobile){
            if(window.matchMedia("(orientation: portrait)").matches) {
                this.state = statePortrait
                }

            else if(window.matchMedia("(orientation: landscape)").matches){
                this.state = stateLandscape
            }
            }
        else{
            console.log("Desktop")
            this.state = stateDesktop
        }
    }
    resize=() =>{

        if(window.matchMedia("(orientation: portrait)").matches){

            this.setState({
                widthDetected: false,
                typicalTextWidth: '10vw',
                typicalMessage: [750],

                awesomeButtonStyle: {position: 'absolute', left: 0, right: 0, margin: 'auto', bottom: '80vh', top: '35vh', height: '4.5vh'},

                myPictureStyle: {display: 'block',marginLeft: '20%', width: '25%'},
                myPicturePosition: 1.25,


                logo1Position: 1.2,
                logo1Style: {display: 'block',marginLeft: '5%', width: '10%'},

                logo2Position: 1.4,
                logo2Style: {display: 'block',marginLeft: '7.5%', width: '5%'},

                logo3Position: 1.6,
                logo3Style: {display: 'block',marginLeft: '7.5%', width: '5%'},

                logo4Position: 1.8,
                logo4Style: {display: 'block',marginLeft: '7.5%', width: '5%'},

                aboutMeTitlePosition: 1.2,
                aboutMeTitleStyle: {color: 'white', marginLeft: '50%', top: '25%', fontSize: '3vw'},
                aboutMeTitleAlign: 'left',

                aboutMeBodyPosition: 1.3,
                aboutMeBodyStyle: {height: '200px',
                    width: '300px', color: 'white', marginLeft: '50%', top: '30%',marginRight: '10%', fontSize: '1.5vw'},

                aboutMeBodyAlign: 'left,'
            })
        }
        else if(window.matchMedia("(orientation: landscape)").matches){
            this.setState({
                typicalMessage: [750],

                typicalTextWidth: '13vw',

                awesomeButtonStyle: {
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    margin: 'auto',
                    bottom: '80vh',
                    top: '35vh',
                    height: '4.5vh'
                },

                logo1Position: 1.14,
                logo1Style: {display: 'block', marginLeft: '10%', width: '20%'},

                logo2Position: 1.15,
                logo2Style: {display: 'block', marginLeft: '35%', width: '10%'},

                logo3Position: 1.15,
                logo3Style: {display: 'block', marginLeft: '55%', width: '10%'},

                logo4Position: 1.15,
                logo4Style: {display: 'block', marginLeft: '75%', width: '10%'},

                myPictureStyle: {display: 'block', margin: 'auto', width: '50%'},
                myPicturePosition: 1.3,

                aboutMeTitlePosition: 1.2,
                aboutMeTitleStyle: {color: 'white', display: 'block', align: 'center', top: '25%', fontSize: '3vh'},
                aboutMeTitleAlign: 'center',

                aboutMeBodyPosition: 1.7,
                aboutMeBodyStyle: {
                    height: '200px',
                    width: '300px',
                    color: 'white',
                    marginLeft: '10%',
                    top: '30%',
                    marginRight: '10%',
                    fontSize: '1.7vh',
                    overflow: 'auto'
                },
                aboutMeBodyAlign: 'center',

            })

        }

    }

    componentDidMount() {
        window.addEventListener('orientationchange', this.resize)
    }

    componentWillUnmount() {
        window.removeEventListener('orientationchange', this.resize)
    }

    render() {
            return (
            <Parallax ref={ref => (this.parallax = ref)} pages={2}>
                <div id={'introPage'} className={'body'} style={{position: 'relative', height: '150vh'}}>
                    <Typography className={'text'} style={{fontSize: this.state.typicalTextWidth}}>
                        <Typical
                            steps={this.state.typicalMessage}
                            loop={Infinity}
                            wrapper="p"
                        />
                    </Typography>
                    <AwesomeButton className={'button'}
                                   type={'secondary'}
                                   size={'large'}
                                   style={this.state.awesomeButtonStyle}
                                   onPress={() => this.parallax.scrollTo( 1)}
                    >
                        Learn about me!
                    </AwesomeButton>

                    <ParallaxLayer offset={1} speed={.2} factor={1} style={{ backgroundColor: 'black' }}/>

                    <ParallaxLayer offset={this.state.aboutMeTitlePosition} speed={.3}>
                        <Typography align={this.state.aboutMeTitleAlign} style={this.state.aboutMeTitleStyle}>
                            Welcome to my Website!
                        </Typography>
                    </ParallaxLayer>

                    <ParallaxLayer offset={this.state.aboutMeBodyPosition} speed={.5}>

                        <Typography align={this.state.aboutMeBodyAlign} style={this.state.aboutMeBodyStyle}>
                            Hi! My name is Michael Ewers and this is my personal website. I have recently graduated from Northern Arizona University with
                            a Bachelor in Computer Science. I have a strong passion for creation within Computer Science and absolutely love the problem solving
                            process which accompanies any solution. I am currently living in Denver, CO and always looking for any opportunity to grow my career in the software industry.
                            to contact me regarding this website or any other inquires, feel free to reach me at Ewers.sw@gmail.com!
                            <br/>

                            <br/>
                            The majority of information and functionality is currently under construction! These web pages have not fully been adapted to mobile browsers. MOBILE USERS BEWARE.
                            Kindly check back another time to see more updates!
                        </Typography>

                    </ParallaxLayer>

                    <ParallaxLayer offset={this.state.myPicturePosition} speed={.4}>
                        <img src={me} style={this.state.myPictureStyle}/>
                    </ParallaxLayer>



                    <ParallaxLayer offset={this.state.logo1Position} speed={.5}>
                        <img src={logo} style={this.state.logo1Style}/>
                    </ParallaxLayer>

                    <ParallaxLayer offset={this.state.logo2Position} speed={.6}>
                        <img src={javaScriptIcon} style={this.state.logo2Style}/>
                    </ParallaxLayer>

                    <ParallaxLayer offset={this.state.logo3Position} speed={.7}>
                        <img src={html} style={this.state.logo3Style}/>
                    </ParallaxLayer>

                    <ParallaxLayer offset={this.state.logo4Position} speed={.8}>
                        <img src={css} style={this.state.logo4Style}/>


                    </ParallaxLayer>
                </div>
            </Parallax>
        );
    }


}
export default IntroPage;